import React, { FC } from "react";
import { FieldError, UseFormGetValues, UseFormRegister } from "react-hook-form";
import classNames from "classnames";
import { FromThirdStepData } from "../../Helpers/interfaces";
import { AppointmentOptionDto } from "../../../../../Model/Blocks/Waitlist/AppointmentOptionDto.csharp";

export type RadioInputProps = {
  label: string;
  name: string;
  register: UseFormRegister<any>;
  options: AppointmentOptionDto[];
  error: FieldError | undefined;
  getValues: UseFormGetValues<FromThirdStepData>;
};

export const RadioInput: FC<RadioInputProps> = ({
  label,
  name,
  register,
  options,
  error,
  getValues,
}) => {
  const getPreselect = (index: number) => {
    const option = options[index];
    if (option.preselected && getValues().remoteContact == option.label) {
      return {
        checked: true,
      };
    }
    return {};
  };

  return (
    <div className="position-relative booking-narrow-item mb-2">
      <span className="input__label--default">{label}</span>
      {options && (
        <div className="d-flex flex-column">
          {options.map((option, index) => (
            <label
              className="position-relative mt-1 input__checkboxContainer"
              key={`${option}-${index}`}
            >
              <input
                {...register(name)}
                className="input__radio"
                type="radio"
                name={name}
                value={option.label.toLowerCase()}
                {...getPreselect(index)}
              />
              <div className="input__radioMimic">
                <div className="input__radioMimicInner" />
              </div>
              <span className="d-">{option.label}</span>
            </label>
          ))}
        </div>
      )}
      {error && error.message && (
        <div
          className={classNames(
            "input__support p-1 mb-2 input__support--error input__support--errorLeft",
            {
              "input__support--error": !error,
            }
          )}
        >
          <p id={"error"} className="fs-6 input__supportText">
            {error.message}
          </p>
        </div>
      )}
    </div>
  );
};
